module.exports = "/_next/static/videos/videoContractSigner-e675349fcc76571cf16104569811243a.mp4";